import gsap from 'gsap';
import EventEmitter from './EventEmitter';

export default class Sizes extends EventEmitter {
	#timer;
	#resizeFn;

	constructor() {
		super();
		if ( Sizes.instance ) return Sizes.instance;
		Sizes.instance = this;
		this.#setDatas();
		this.prevDevice = this.device;
		this.#resizeFn = () => {
			this.#timer?.kill();
			this.#timer = gsap.delayedCall( 0.5, () => {
				this.prevDevice = this.device;
				this.#setDatas();
				if ( this.prevDevice !== this.device ) {
					this.trigger( 'resize' );
				}
			} );
		};
		window.addEventListener( 'resize', this.#resizeFn );
	}

	destroy() {
		window.removeEventListener( 'resize', this.#resizeFn );
		this.#timer = null;
		this.#resizeFn = null;
		this.width = null;
		this.height = null;
		this.pixelRatio = null;
		this.device = null;
		this.prevDevice = null;
	}

	#setDatas() {
		this.width = window.innerWidth;
		this.height = window.innerHeight;
		this.pixelRatio = window.devicePixelRatio;
		this.device = 'Desktop';
		this.aspect = 'Landscape';

		if (
			( this.width &&
				this.width <= 1200 &&
				this.width > 900 &&
				this.width >= this.height ) ||
			( this.width &&
				this.width <= 900 &&
				this.width > 600 &&
				this.width < this.height )
		) {
			this.device = 'Tablet';
		} else if (
			( this.width && this.width <= 900 && this.width >= this.height ) ||
			( this.width && this.width <= 600 )
		) {
			this.device = 'Mobile';
		}

		if ( this.width < this.height ) {
			this.aspect = 'Portrait';
		}
	}
}
